import { render } from "./SwitchBtn.vue?vue&type=template&id=253fbf06&scoped=true"
import script from "./SwitchBtn.vue?vue&type=script&lang=js"
export * from "./SwitchBtn.vue?vue&type=script&lang=js"

import "./SwitchBtn.vue?vue&type=style&index=0&id=253fbf06&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-253fbf06"]])

export default __exports__